// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NoVideoMinimize__container-a9a3ad {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  align-self: center;
  background-color: var(--addition-80);
  border-radius: 8px;
  width: 100%;
  height: 200px;
  padding: 24px;
  box-sizing: border-box;
}

.NoVideoMinimize__title-deb100 {
  margin-top: 8px;
  color: var(--addition-50);
  font: var(--font-body-2);
  max-width: 260px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/main/LiveStreaming/SharedComponents/NoVideoMinimize/styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;EACA,yBAAA;EACA,wBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  align-self: center;\n  background-color: var(--addition-80);\n  border-radius: 8px;\n  width: 100%;\n  height: 200px;\n  padding: 24px;\n  box-sizing: border-box;\n}\n\n.title {\n  margin-top: 8px;\n  color: var(--addition-50);\n  font: var(--font-body-2);\n  max-width: 260px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NoVideoMinimize__container-a9a3ad`,
	"title": `NoVideoMinimize__title-deb100`
};
module.exports = ___CSS_LOADER_EXPORT___;
